import { http } from '@/services'

export default {

    salvar:(prova) =>{
        return http.post('prova/', prova)
    },
    getProvaList: async function() {
        return await http.get('prova/');
    },
    getProvaListPorProduto: async function(idResidencia) {
        return await http.get('prova/residencia', {
            params: idResidencia,
        });
    },
    excluirProva: async function(idProva) {
        return await http.delete(`prova/${idProva}`);
    },
    updateProva: async function(idProva) {
        return await http.put(`prova/download/${idProva}`)
    }
}